import adminApi from '@/apis/admin'

export default {
  state: {
    entries: [],
    total: 0,
    limit: 50,
    offset: 0,
    filters: {},
    loading: false
  },
  mutations: {
    SET_ADMIN_AUDIT_RESULT(state, { entries, total, limit, offset }) {
      state.entries = entries || []
      state.total = total || 0
      state.limit = limit || state.limit
      state.offset = offset || 0
    },
    SET_ADMIN_AUDIT_FILTERS(state, filters) {
      state.filters = filters || {}
    },
    SET_ADMIN_AUDIT_LOADING(state, loading) {
      state.loading = !!loading
    }
  },
  actions: {
    async fetchAdminAudit({ commit, state }, override) {
      const params = { ...state.filters, limit: state.limit, offset: state.offset, ...(override || {}) }
      commit('SET_ADMIN_AUDIT_LOADING', true)
      try {
        const resp = await adminApi.listAudit(params)
        const body = resp.data || {}
        if (body.success) commit('SET_ADMIN_AUDIT_RESULT', body.data)
        return body
      } finally {
        commit('SET_ADMIN_AUDIT_LOADING', false)
      }
    }
  }
}
